import React from "react";
import { Link } from "react-router-dom";

export default function AccessDenied() {
  return (
    <div className="w-screen h-screen bg-black flex flex-col items-center justify-center text-center relative">

      {/* Pulsing neon glow background */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-[#001a14] to-black animate-pulseGlow opacity-70"></div>

      {/* Glowing border box */}
      <div className="
        relative p-10 rounded-2xl 
        border border-[#00FF99]/40 
        bg-white/5 backdrop-blur-xl 
        shadow-[0_0_25px_#00FF99] 
        animate-fadeIn
        max-w-lg mx-auto
      ">
        <h1 className="text-4xl font-bold text-[#00FF99] mb-4">
          Access Denied
        </h1>

        <p className="text-white/70 text-sm mb-6">
          You do not have permission to access this page.
          <br />
          If you believe this is an error, please contact your administrator.
        </p>

        <Link
          to="/"
          className="
            px-6 py-2 rounded-lg text-black font-semibold
            bg-[#00FF99] hover:bg-[#00FF99]/90 
            shadow-[0_0_15px_#00FF99] hover:shadow-[0_0_25px_#00FF99]
            transition-all duration-300
          "
        >
          Return to Home
        </Link>
      </div>
    </div>
  );
}
